import { useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { CheckCheck, X } from "lucide-react";
import { NotificationItem } from "./NotificationItem";

export const NotificationSheet = ({ items, unread, onRead, onReadAll, onClose }) => {
  const { t } = useTranslation();
  const [unreadOnly, setUnreadOnly] = useState(false);
  const visible = unreadOnly ? items.filter((i) => !i.read) : items;

  // Portal: البطاقات الأم لها طبقات أدنى من الشريط السفلي، فنعرض اللوحة على جسم الصفحة.
  return createPortal(
    <>
      <div className="fixed inset-0 z-[60] bg-black/50 lg:bg-transparent" onClick={onClose} data-testid="notification-overlay" />
      <div
        data-testid="notification-panel"
        className="fixed inset-x-0 bottom-0 z-[70] max-h-[70vh] overflow-y-auto rounded-t-3xl border-t border-border/60 bg-background p-5 pb-[max(7rem,calc(env(safe-area-inset-bottom)+6.5rem))] shadow-neu lg:inset-x-auto lg:bottom-auto lg:start-4 lg:top-20 lg:max-h-96 lg:w-96 lg:rounded-3xl lg:border lg:pb-5"
      >
        <div className="flex items-center justify-between gap-2">
          <p className="label-xs">
            {t("notifications.title")}
            {unread ? <span className="ms-2 font-mono text-primary">{unread}</span> : null}
          </p>
          <div className="flex items-center gap-1.5">
            {unread ? (
              <button
                type="button"
                onClick={onReadAll}
                data-testid="notification-read-all"
                className="flex items-center gap-1.5 rounded-xl px-2.5 py-1.5 text-[11px] font-bold shadow-neu-sm transition-[box-shadow] hover:shadow-neu-in"
              >
                <CheckCheck className="h-3.5 w-3.5" /> {t("notifications.markAll")}
              </button>
            ) : null}
            <button type="button" data-testid="notification-close" onClick={onClose} className="rounded-full p-1.5 shadow-neu-sm">
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>

        <div className="mt-3 flex gap-2">
          {[false, true].map((flag) => (
            <button
              key={String(flag)}
              type="button"
              onClick={() => setUnreadOnly(flag)}
              data-testid={`notification-filter-${flag ? "unread" : "all"}`}
              className={`rounded-xl px-3 py-1.5 text-[11px] font-bold transition-[box-shadow] ${
                unreadOnly === flag ? "shadow-neu-in text-primary" : "shadow-neu-sm"
              }`}
            >
              {t(flag ? "notifications.filterUnread" : "notifications.filterAll")}
            </button>
          ))}
        </div>

        {!visible.length ? (
          <p className="mt-4 text-sm text-muted-foreground" data-testid="notification-empty">
            {t(unreadOnly ? "notifications.emptyUnread" : "notifications.empty")}
          </p>
        ) : (
          <ul className="mt-2 grid gap-1">
            {visible.map((item) => (
              <NotificationItem key={item.id} item={item} onRead={onRead} onClose={onClose} />
            ))}
          </ul>
        )}
      </div>
    </>,
    document.body
  );
};
